import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './actions';
import { IndexType } from '@fnModels/algolia/algolia';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';

export type FireInsuranceBrokersSearchStateModel = AlgoliaBaseState<unknown>;

@State<FireInsuranceBrokersSearchStateModel>({
	name: 'fireInsuranceBrokersSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class FireInsuranceBrokersSearchState extends AlgoliaSearchState<FireInsuranceBrokersSearchStateModel> {
	protected indexName = getIndex(IndexType.FIRE_INSURANCE_BROKERS);

	@Selector([FireInsuranceBrokersSearchState])
	static getList(state: FireInsuranceBrokersSearchStateModel): unknown[] {
		return state?.items;
	}

	@Selector([FireInsuranceBrokersSearchState])
	static getSearching(state: FireInsuranceBrokersSearchStateModel): boolean {
		return state?.searching;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<FireInsuranceBrokersSearchStateModel>,
		{ payload }: actions.Search,
	): Promise<void> {
		const facetFilters = [];
		if (payload?.brokerageId) {
			facetFilters.push(`brokerageId:${payload.brokerageId}`);
		}

		await this.algoliaSearchHandler(ctx, payload?.searchTerm, {
			facetFilters,
		});
	}
}
